import _ from 'underscore';
import moment from 'moment';

angular.module('am4')
.controller('facCtrl', function(
    $log,
    $q,
    $scope,
    $rootScope,
    $state,
    $stateParams,
    $translate,
    config,
    facilityData,
    subscriptions,
    ngDialog,
    user,
    subscriptionService,
    orgFacService,
    imageService,
    contactService,
    equipmentGroupService,
    errorService,
    nonconnectedMachineService,
    serviceRequestService,
    errorCodeService,
    appCacheService,
    geoService,
    ecofitService,
    facilityContact) {

    var that = this,
        subscriptionId = null;

    that.errorCodes = [];
    that.errorCodesLoaded = false;
    that.nonconnectedMachines = [];
    that.nonconnectedMachinesLoaded = false;
    that.equipmentGroups = [];
    that.equipmentGroupsLoaded = false;
    that.serviceRequests = [];
    that.serviceRequestsLoaded = false;
    that.pageLength = 10;
    that.contact = facilityContact || {};
    that.ecofitData = {};

    that.initVisibleNumberUiSelectChoices = 20;
    that.visibleNumberUiSelectChoices = that.initVisibleNumberUiSelectChoices;

    that.canViewMachineData = user.permissions.includes('EQUIPMENT_PAGE');
    that.canViewEcofitData = user.permissions.includes('ECOFIT');

    $state.go(
        that.canViewMachineData
            ? 'app.am4.facility.errorcodes'
            : 'app.am4.facility.calendar',
        { id: $stateParams.id }, { location: 'replace' });

    $scope.$on('uiSelectInfiniteScroll:resetLimit', function() {
        that.visibleNumberUiSelectChoices = that.initVisibleNumberUiSelectChoices;
    });

    that.showMoreUiSelectChoices = function() {
        that.visibleNumberUiSelectChoices += that.initVisibleNumberUiSelectChoices;
    };

    // up here because hoisting
    that.setPagination = function(newPage) {
        // if valid page
        if (newPage > 0 && newPage < that.numPages + 1) {
            // make correct range for displayed pages
            if (that.numPages <= 5) {
                that.pages = _.range(1, that.numPages + 1);
            } else if (newPage <= 2) {
                that.pages = _.range(1, 6);
            } else if (newPage >= that.numPages - 1) {
                that.pages = _.range(that.numPages - 4, that.numPages + 1);
            } else {
                that.pages = _.range(newPage - 2, newPage + 3);
            }

            // pick if we can select prev and next buttons
            that.prev = newPage === 1;
            that.next = newPage === that.numPages;

            // finally, set current page to the new value
            that.currentPage = newPage;

            that.visibleNCEquipment = that.nonconnectedMachines.slice((that.currentPage - 1) * that.pageLength, that.currentPage * that.pageLength);
        }
    };
    that.numPages = Math.ceil(that.nonconnectedMachines.length / that.pageLength);
    that.setPagination(1);

    that.id = +$state.params.id;

    that.data = facilityData;

    $scope.$on('nonconnectedEquipment:update', function() {
        nonconnectedMachineService.getFacilityNonconnectedMachines($stateParams.id)
        .then(function(ncmach) {
            that.nonconnectedMachines = ncmach;
            that.numPages = Math.ceil(that.nonconnectedMachines.length / that.pageLength);
            that.setPagination(1);
        })
        .finally(function() {
            that.nonconnectedMachinesLoaded = true;
        });
    });

    $scope.$on('equipmentGroups:update', function() {
        equipmentGroupService.getEquipmentGroups($stateParams.id)
        .then(function(res) {
            that.equipmentGroups = res;
        })
        .finally(function() {
            that.equipmentGroupsLoaded = true;
        });
    });

    $scope.$on('serviceRequests:update', function() {
        serviceRequestService.getFacilityServiceRequests($stateParams.id)
        .then(function(res) {
            that.serviceRequests = res;
        })
        .finally(function() {
            that.serviceRequestsLoaded = true;
        });
    });

    $scope.$on('facilityAddress:update', function() {
        orgFacService.getFacility($stateParams.id)
        .then(function(data) {
            that.data = data;
        });
    });

    that.goToEquipment = function() {
        var state = appCacheService.getAppCache('appState');

        state.dashboardOptions = {
            machine_type_code: [],
            series: [],
            facility_id: [that.id],
            organization_id: [],
            status: []
        };

        $state.go('app.am4.dashboard.results');
    };

    that.subscribed = false;
    subscriptions.forEach(function(subscription) {
        if (subscription.facility_id === that.id) {
            that.subscribed = true;
            subscriptionId = subscription.id;
        }
    });

    that.subscribe = function() {
        that.subscribing = true;

        subscriptionService.createUserSubscription(user.user_id, {
            facility_id: that.id
        })
        .then(function success(data) {
            that.subscribing = false;
            that.subscribed = true;
            subscriptionId = data[0].id;
        })
        .catch(function(e) {
            errorService.addError('SUBSCRIBE_ERROR', e);
        });
    };

    that.unsubscribe = function() {
        that.subscribing = true;

        subscriptionService.deleteUserSubscription(user.user_id, subscriptionId)
        .then(function success() {
            that.subscribing = false;
            that.subscribed = false;
            subscriptionId = null;
        })
        .catch(function(e) {
            errorService.addError('UNSUBSCRIBE_ERROR', e);
        });
    };

    that.deactivate = function() {
        if ($rootScope.userPermissions.indexOf('JHT_ORG_FAC_MANAGEMENT') !== -1 && that.data.is_active) {
            var dangerScope = $scope.$new();
            dangerScope.confirmTranslation = 'COMFIRM_DEACTIVATE_FACILITY';
            dangerScope.confirmTranslationValues = {
                item: facilityData.name
            };
            ngDialog.openConfirm({
                template: require('../views/modal/danger.html'),
                plain: true,
                scope: dangerScope,
                className: 'ngdialog-theme-plain--danger'
            })
            .then(function removeConfirmed() {
                that.deactivating = true;

                return orgFacService.deactivateFacility(that.id)
                .then(function() {
                    that.data.is_active = false;
                })
                .catch(function(e) {
                    errorService.addError('FACILITY_DEACTIVATION_ERROR', e);
                });
            })
            .finally(function() {
                that.deactivating = false;
            });
        }
    };

    // Not currently in use
    that.reactivate = function() {
        if ($rootScope.userPermissions.indexOf('JHT_ORG_FAC_MANAGEMENT') !== -1 && !that.data.is_active) {
            that.deactivating = true;

            orgFacService.reactivateFacility(that.id)
            .then(function() {
                that.data.is_active = true;
            })
            .finally(function() {
                that.deactivating = false;
            })
            .catch(function(e) {
                errorService.addError('FACILITY_REACTIVATION_ERROR', e);
            });
        }
    };

    that.editName = function() {
        var editScope = $scope.$new();

        editScope.name = that.data.name;
        editScope.renameTranslation = 'RENAME_FACILITY';

        ngDialog.openConfirm({
            template: require('../views/modal/rename.html'),
            plain: true,
            scope: editScope
        })
        .then(function renameSuccess(newName) {
            return orgFacService.updateFacility(that.id, {
                name: newName
            })
            .catch(function(e) {
                errorService.addError('UPDATE_FACILITY_ERROR', e);
            });
        });
    };

    that.editNickname = function() {
        var editScope = $scope.$new();

        editScope.nickname = that.data.nickname;
        editScope.renameTranslation = 'EDIT_FACILITY_NICKNAME';

        ngDialog.openConfirm({
            template: require('../views/modal/editNickname.html'),
            plain: true,
            scope: editScope
        })
        .then(function renameSuccess(newNickname) {
            return orgFacService.updateFacility(that.id, {
                nickname: newNickname
            })
            .catch(function(e) {
                errorService.addError('UPDATE_FACILITY_ERROR', e);
            });
        });
    };

    that.timeZones = moment.tz.names();

    that.saveTimeZone = function($item) {
        return orgFacService.updateFacility(that.id, {
            time_zone: $item
        })
        .catch(function(e) {
            errorService.addError('UPDATE_FACILITY_ERROR', e);
        });
    };
    that.guessTimeZone = function(isOpen, $select) {
        if (isOpen && (!that.data.time_zone || that.data.time_zone === 'UTC')) {
            // If the time zone is undefined or set to UTC
            // then take a guess and put the guess at the top of the list
            var timeZoneGuess = moment.tz.guess();
            that.timeZones.splice(that.timeZones.indexOf(timeZoneGuess), 1);
            that.timeZones.unshift(moment.tz.guess());

            // Highlight the guess
            $select.activeIndex = 0;
        }
    };

    that.editAddress = function() {
        var editScope = $scope.$new();

        editScope.address = that.data.address;
        editScope.facility_id = that.id;
        editScope.renameTranslation = 'EDIT_FACILITY_ADDRESS';

        ngDialog.openConfirm({
            template: require('../views/modal/editFacilityAddress.html'),
            plain: true,
            scope: editScope,
            controller: 'editAddressCtrl',
            controllerAs: 'addressCtrl',
            resolve: {
                countries: function() {
                    return geoService.getCountries();
                }
            }
        });
    };

    that.createEquipmentGroup = function() {
        var createEGScope = $scope.$new(),
            dialog = ngDialog.open({
                template: require('../views/modal/createEquipmentGroup.html'),
                plain: true,
                scope: createEGScope
            });

        createEGScope.submit = function(groupName) {
            createEGScope.isSaving = true;

            equipmentGroupService.createEquipmentGroup(that.id, groupName)
            .then(function(res) {
                that.equipmentGroups = res;
            })
            .finally(function() {
                createEGScope.isSaving = false;
                dialog.close();
            })
            .catch(function(e) {
                errorService.addError('CREATE_EQUIPMENT_GROUP_ERROR', e);
            });
        };
    };

    that.editGroupName = function(group, index) {
        var editEGScope = $scope.$new();

        editEGScope.name = group.name;
        editEGScope.renameTranslation = 'RENAME_EQUIPMENT_GROUP';

        ngDialog.openConfirm({
            template: require('../views/modal/rename.html'),
            plain: true,
            scope: editEGScope
        })
        .then(function renameSuccess(newName) {
            return equipmentGroupService.updateEquipmentGroup(that.id, group.group_id, { name : newName })
            .then(function(res) {
                that.equipmentGroups[index] = res;
            })
            .catch(function(e) {
                errorService.addError('UPDATE_EQUIPMENT_GROUP_ERROR', e);
            });
        });
    };

    that.deleteEquipmentGroup = function(groupId) {

        var deleteEGScope = $scope.$new(),
            dialog = ngDialog.open({
                template: require('../views/modal/deleteEquipmentGroup.html'),
                plain: true,
                scope: deleteEGScope,
                className: 'ngdialog-theme-plain--danger'
            });

        deleteEGScope.submit = function() {
            deleteEGScope.isSaving = true;

            equipmentGroupService.deleteEquipmentGroup(that.id, groupId)
            .then(function(res) {
                that.equipmentGroups = res;
            })
            .finally(function() {
                deleteEGScope.isSaving = false;
                dialog.close();
            })
            .catch(function(e) {
                errorService.addError('DELETE_EQUIPMENT_GROUP_ERROR', e);
            });
        };
    };

    // Called when facilities page first loads.
    that.refreshErrorCodes = function() {

        that.errorCodes = [];

        that.errorCodesLoaded = false;
        errorCodeService.getFacilityErrorCodes($stateParams.id, null, $rootScope.logged_in_user.user_metadata.am_roles)
        .then(function(res) {
            that.errorCodes = res;
        })
        .catch(function(e) {
            errorService.addError('GET_ALERTS_ERROR', e);
        }).finally(function() {
            that.errorCodesLoaded = true;
        });
    };

    that.nextErrorCodesBatch = function() {
        var nextBatchStartDate = that.errorCodes[that.errorCodes.length - 1].recorded_at;

        // The GMT-converted date was being used here, instead of the date/time value that corresponds with the facility's time
        // zone. This was preventing the UI from fetching the next 10 errors, as the date it was using here
        // was always incorrect.
        // eslint-disable-next-line one-var
        var timeZoneDate = moment(nextBatchStartDate).tz(this.data.time_zone).format('YYYY-MM-DDTHH:mm:ss');

        that.errorCodes = [];
        that.errorCodesLoaded = false;
        errorCodeService.getFacilityErrorCodes($stateParams.id, timeZoneDate, $rootScope.logged_in_user.user_metadata.am_roles)
        .then(function(res) {
            that.errorCodes = res;
        })
        .catch(function(e) {
            errorService.addError('GET_ALERTS_ERROR', e);
        }).finally(function() {
            that.errorCodesLoaded = true;
        });
    };

    that.getFacilityContact = function() {
        return contactService.getFacilityContact(that.id)
        .then(contact => {
            that.contact = contact;
        });
    };

    that.editFacilityContact = function() {
        const editFacilityContact = $scope.$new();

        editFacilityContact.contact_email = that.contact.contact_email || '';
        editFacilityContact.contact_phone_number = that.contact.contact_phone_number || '';

        ngDialog.openConfirm({
            template: require('../views/modal/editContact.html'),
            plain: true,
            scope: editFacilityContact
        })
        .then(function(updated) {
            return contactService.setFacilityContact(that.id, updated)
            .then(() => {
                return that.getFacilityContact();
            })
            .catch(function(e) {
                errorService.addError('UPDATE_CONTACT_ERROR', e);
            });
        });
    };

    that.getEcofitData = function() {
        ecofitService.getFacilityEcofitData(that.id)
        .then((data) => {
            that.ecofitData = data;
        })
        .catch(() => {
            that.ecofitData = {};
        });
    };

    that.editEcofitData = function() {
        const editEcofitData = $scope.$new();

        editEcofitData.touchscreen_count = that.ecofitData.touchscreen_count || 0;
        editEcofitData.led_count = that.ecofitData.led_count || 0;
        editEcofitData.sales_contact_email = that.ecofitData.sales_contact_email || '';

        ngDialog.openConfirm({
            template: require('../views/modal/editEcofitData.html'),
            plain: true,
            scope: editEcofitData
        })
        .then(function(updated) {
            return ecofitService.upsertFacilityEcofitData(that.id, updated)
            .then(() => {
                return that.getEcofitData();
            })
            .catch(function(e) {
                errorService.addError('UPDATE_ECOFIT_ERROR', e);
            });
        });
    };

    that.hasOrgReadPerm = function() {
        return $rootScope.userPermissions.indexOf('ORG_READ') > -1;
    };

    that.hasOrgAdminPerm = function() {
        return $rootScope.userPermissions.indexOf('ORG_ADMIN') > -1;
    };

    that.nextErrorCodesBatchText = $translate.instant('NEXT_N_EVENTS', { n: config.errorCodeServiceRange });

    that.hasGroupPermissions = function() {
        return $rootScope.userPermissions.indexOf('FACILITY_EQUIPMENT_GROUPS') > -1;
    };

    that.hasNCEPermissions = function() {
        return $rootScope.userPermissions.indexOf('FACILITY_NONCONNECTED_EQUIPMENT') > -1;
    };

    that.hasAdminPermissions = function() {
        return $rootScope.userPermissions.indexOf('FACILITY_ADMIN') > -1;
    };

    that.hasContactPermissions = function() {
        return $rootScope.userPermissions.indexOf('FACILITY_CONTACTS') > -1;
    };

    // Initial data load for our tabs
    if ( that.canViewMachineData ) {
        that.refreshErrorCodes();
    }
    if (that.canViewEcofitData) {
        that.getEcofitData();
    }
    $scope.$broadcast('nonconnectedEquipment:update');
    $scope.$broadcast('equipmentGroups:update');
    $scope.$broadcast('serviceRequests:update');
});



// WEBPACK FOOTER //
// ./src/app/controllers/facCtrl.js